/**
 * Staple It — Warm Kitchen Palette
 *
 * sage:       Primary brand — fresh herbs, farmers market
 * terracotta: Action accent — cooked food, warm clay
 * butter:     Highlights, tips, delight moments
 * linen:      Warm neutrals (replaces cold grays)
 * rose:       Tags, badges, soft warmth accent
 */

export const colors = {
  // --- Brand: Sage Green ---
  sage: {
    50:  '#F2F7F2',
    100: '#E0EBE0',
    200: '#C1D7C1',
    300: '#97BC97',
    400: '#6FA06F',
    500: '#5B8A5B',
    600: '#4A7A4A',
    700: '#3D6B3D',
    800: '#2F5A2F',
    900: '#1E3E1E',
  },

  // --- Accent: Terracotta ---
  terracotta: {
    50:  '#FEF3EE',
    100: '#FDDEC9',
    200: '#FBBF93',
    300: '#F8A065',
    400: '#F08040',
    500: '#D96A2B',
    600: '#B85620',
    700: '#964518',
    800: '#753512',
    900: '#54250C',
  },

  // --- Accent: Butter Yellow ---
  butter: {
    50:  '#FFFDF5',
    100: '#FFF8E1',
    200: '#FFEFB8',
    300: '#FFE58F',
    400: '#FFD966',
    500: '#E6C04A',
    600: '#C9A533',
    700: '#A38622',
    800: '#7D6716',
    900: '#574A0E',
  },

  // --- Warm Neutral: Linen (replaces gray) ---
  linen: {
    50:  '#FDFCFA',
    100: '#F8F5F0',
    200: '#F0EBE3',
    300: '#E3DCD1',
    400: '#CFC5B6',
    500: '#B0A594',
    600: '#8C8070',
    700: '#6B604F',
    800: '#4A4237',
    900: '#302A22',
    950: '#1E1A15',
  },

  // --- Accent: Dusty Rose ---
  rose: {
    50:  '#FDF2F4',
    100: '#FAE0E4',
    200: '#F5BFC8',
    300: '#EF9DAE',
    400: '#E87B94',
    500: '#D46078',
    600: '#B84A60',
    700: '#9A3A4E',
    800: '#7C2D3E',
    900: '#5E2030',
  },

  // --- Cooking technique colors (warmed) ---
  technique: {
    saute:  '#E8934A',
    boil:   '#5B9BD5',
    bake:   '#D46078',
    grill:  '#C5524A',
    fry:    '#E6C04A',
    roast:  '#D96A2B',
    simmer: '#9B7BB8',
    steam:  '#6BAFA6',
    toss:   '#6FA06F',
    mix:    '#5BA8C8',
    chop:   '#B0A594',
    rest:   '#CFC5B6',
    chill:  '#7BB5D4',
    whisk:  '#C9A533',
    fold:   '#D990A8',
  },

  // --- Difficulty ---
  difficulty: {
    easy:   '#6FA06F',
    medium: '#E8934A',
    hard:   '#C5524A',
  },

  // Keep "brand" as alias so existing colorScheme="brand" doesn't break
  brand: {
    50:  '#F2F7F2',
    100: '#E0EBE0',
    200: '#C1D7C1',
    300: '#97BC97',
    400: '#6FA06F',
    500: '#5B8A5B',
    600: '#4A7A4A',
    700: '#3D6B3D',
    800: '#2F5A2F',
    900: '#1E3E1E',
  },
};
